import { render, staticRenderFns } from "./ProductFeedList.vue?vue&type=template&id=d0bb1844&scoped=true&"
import script from "./ProductFeedList.vue?vue&type=script&lang=js&"
export * from "./ProductFeedList.vue?vue&type=script&lang=js&"
import style0 from "./ProductFeedList.vue?vue&type=style&index=0&id=d0bb1844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bb1844",
  null
  
)

export default component.exports